<template>
  <div>
    <section class="toolbar">
      <div class="toolbar-container">
        <router-link v-bind:to="'/operator/home-page'">
          <img src="/static/images/back.png" />
        </router-link>
        <h1>
          <label>Mail Logs</label>
        </h1>
      </div>
    </section>
    <div id="graph-container" class="section-chart">
      <!--<div id="container" class="highcharts-container"></div>-->
    </div>

    <div class="table-email-container">
      <div class="form-group">
        <input type="email" class="form-control" id="email" placeholder="Enter email" name="email" />
        <button
          v-on:click="sendMail()"
          :disabled="loadingLogs"
          class="btn btn-default table-email-btn"
        >{{sendMailButtonTitle}}</button>
      </div>
    </div>
    <div id="mailer-container">
      <header
        id="mail-header"
        style="float: left; width: 100%; padding: 15px; -webkit-box-sizing: border-box;-moz-box-sizing: border-box;box-sizing: border-box;"
      >
        <div class="logo" style="float: left; width: 33%;">
          <img
            src="data:image/png;base64,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"
          />
        </div>
        <div
          class="drivers-log-info"
          style="width: 33%; display: inline-block; text-align: center;"
        >
          <span
            style="width: 100%; display: inline-block; text-align: center; font-size: 24px;
              color: #333; font-family: Arial, Helvetica, sans-serif;"
          >DRIVER'S DAILY LOG</span>
          <p
            style="width: 100%; display: inline-block; text-align: center; font-size: 16px;
              color: #666; font-family: Arial, Helvetica, sans-serif; margin:5px 0 0 0;"
          >{{ shiftProperty }}</p>
        </div>
        <div
          class="logdate"
          style="float: right; width: auto; font-size: 16px; color: #666; padding: 20px 0 0 0; font-family: Arial, Helvetica, sans-serif;"
        >
          <strong style="font-weight: normal; color: #333;">Date:</strong>
          {{ currDate }}
        </div>
      </header>
      <section
        id="operator-info"
        class="driver-info"
        style="float: left; width: 98%;   margin: auto 1%; -webkit-box-sizing: border-box;-moz-box-sizing: border-box;box-sizing: border-box;"
      >
        <div
          class="driver-block"
          style="float: left;width: 50%;padding: 10px 15px;border: 1px solid #ddd;margin-top: -1px;margin-right: -1px; -webkit-box-sizing: border-box;-moz-box-sizing: border-box;box-sizing: border-box;"
        >
          <div
            class="left"
            style="width: 40%; font-size: 15px; color: #333; float: left; font-weight: bold; font-family: Arial, Helvetica, sans-serif;"
          >Operator Name</div>
          <div
            class="right"
            style="width: 60%; float: left; font-size: 16px; color: #666; font-family: Arial, Helvetica, sans-serif;"
          >{{ operatorData[0].fname }} {{ operatorData[0].lname }}</div>
        </div>
        <div
          class="driver-block"
          style="float: left;width: 50%;padding: 10px 15px;border: 1px solid #ddd;margin-top: -1px;margin-right: -1px; -webkit-box-sizing: border-box;-moz-box-sizing: border-box;box-sizing: border-box;"
        >
          <div
            class="left"
            style="width: 40%; font-size: 15px; color: #333; float: left; font-weight: bold; font-family: Arial, Helvetica, sans-serif;"
          >CDL NO</div>
          <div
            class="right"
            style="width: 60%; float: left; font-size: 16px; color: #666; font-family: Arial, Helvetica, sans-serif;"
          >{{ operatorData[0].cdl }}</div>
        </div>
        <div
          class="driver-block"
          style="float: left;width: 50%;padding: 10px 15px;border: 1px solid #ddd;margin-top: -1px;margin-right: -1px; -webkit-box-sizing: border-box;-moz-box-sizing: border-box;box-sizing: border-box;"
        >
          <div
            class="left"
            style="width: 40%; font-size: 15px; color: #333; float: left; font-weight: bold; font-family: Arial, Helvetica, sans-serif;"
          >Customer DOT NO</div>
          <div
            class="right"
            style="width: 60%; float: left; font-size: 16px; color: #666; font-family: Arial, Helvetica, sans-serif;"
          >{{ operatorData[0].dot }}</div>
        </div>
      </section>
      <section
        class="footer"
        style="float: left; width: 100%; text-align: center; font-size: 14px; color: #666;padding-bottom: 15px; -webkit-box-sizing: border-box;-moz-box-sizing: border-box;box-sizing: border-box; font-family: Arial, Helvetica, sans-serif;"
      >Copyright © 2020 VTRL ELD.</section>
    </div>
    <div class="table-btn-container"></div>
  </div>
</template>

<script>
import Highcharts from "highcharts";
import html2canvas from "html2canvas";

export default {
  name: "assetselection",
  data: () => ({
    labelArray: ["", "ON", "D", "SB", "OFF"],
    startX: 0,
    startY: 0,
    selected_date: "",
    formattedDate: "",
    total_time: "",
    sign_image: "",
    logsArray: [
      {
        Date: "",
        LogData: {
          logData: {
            items: {}
          }
        }
      }
    ],
    items: {},
    operatorData: [
      {
        fname: "",
        lname: "",
        cdl: "",
        dot: ""
      }
    ],
    graph_data: {},
    total_hours: {},
    signReceived: true,
    inspectionList: [],
    showTrailerDefects: false,
    showVehicleDefects: false,
    serverPath: "",
    chart: null,
    options: {},
    currDate: "",
    shiftProperty: "",
    loadingLogs: false,
    sendMailButtonTitle: "Send Mail"
  }),
  beforeCreate: function() {
    let geoLocation = document.createElement("script");
    geoLocation.setAttribute(
      "src",
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyAxR9iECiPUyY6Tn0kAU2SFturhVMbOyIM"
    );
    document.head.appendChild(geoLocation);
  },
  mounted: function() {
    this.call();
  },
  methods: {
    exportImageFromChart: function(divId) {
      //alert("DIv ID " + divId);
      //URL to Highcharts export server
      /*var exportUrl = 'http://export.highcharts.com/';
    
            //POST parameter for Highcharts export server
            var object = {
                options: JSON.stringify(this.options),
                type: 'image/png',
                async: true
            };
            console.log(this.options);
    
            //Ajax request
            $.ajax({
                type: 'post',
                url: exportUrl,
                data: object,
                success: function (data) {
                    // Update "src" attribute with received image URL
                    $('#chart').attr('src', exportUrl + data);
                }
            });*/
      var self = this;
      document.getElementById("container-" + divId).style.display = "block";
      html2canvas(document.querySelector("#container-" + divId)).then(function(
        canvas
      ) {
        document.querySelector("#container-" + divId).style.display = "none";
        self.cb(canvas, divId);
      });
    },
    cb: function(canvas, divId) {
      //document.body.appendChild(canvas);
      var image = canvas.toDataURL("image/png");
      var self = this;
      $("#img-" + divId).attr("src", image);
      // Convert and download as image
      //Canvas2Image.saveAsPNG(canvas);
      //$("#chart").attr('src',image);
      /*$.ajax({
                url: self.$config.API + "/v1/operator/upload-log-chart-image", // + self.$route.query.selected_date,
                type: "POST",
                crossDomain: true,
                data: { "image_path": image },
                xhrFields: {
                    withCredentials: true
                },
                success: function(res) {
                    if (res.code == 200) {
                        //alert(res.messge);
                        $("#chart").attr('src', self.$config.API + "/" + res.data.image_path);
                    }
                },
                error: function(jqXHR, exception) {
                    //if session expired
                    if (jqXHR.responseJSON.code == 401) {
                        self.$router.push(
                            "/v1/operator/login"
                        )
                    } else if (jqXHR.responseJSON.code == 400) {
                        alert(jqXHR.responseJSON.messge);
                    }
                }
            });*/
    },
    sendMail: function() {
      var email = $("#email").val();
      if (email == "") {
        alert("Please enter email address");
        $("#email").focus();
        return;
      }
      var htmlData = {
        data: LZString.compressToEncodedURIComponent(
          $("#mailer-container").html()
        ),
        email: email,
        total_logs: this.logsArray.length
      };
      var self = this;
      // $(".loading").removeClass("hide");
      self.$config.loading = true;
      this.loadingLogs = true;
      this.sendMailButtonTitle = "Sending Mail...";
      $.ajax({
        url: self.$config.API + "/v1/operator/sendmail",
        type: "POST",
        data: htmlData,
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        },
        timeout: 60000,
        success: function(data) {
          self.$config.loading = false;
          self.loadingLogs = false;
          self.sendMailButtonTitle = "Send Mail";

          // $(".loading").addClass("hide");
          $("#email").val("");

          if (data.status == "success") {
            alert(data.message);
          }
          console.log(data);
        },
        error: function(jqXHR, exception, textstatus) {
          self.$config.loading = false;
          self.loadingLogs = false;
          self.sendMailButtonTitle = "Send Mail";
          //if session expired
          if (textstatus === "timeout") {
            alert("Request timeout");
          } else if (jqXHR.responseJSON.code == 401) {
            self.$router.push("/v1/operator/login");
          } else if (jqXHR.responseJSON.code == 400) {
            alert(jqXHR.responseJSON.messge);
          }
        }
      });
    },
    call: function() {
      var self = this;
      self.$config.loading = true;
      $.ajax({
        url:
          self.$config.API + "/v1/operator/get-send-log-data?date=2018-02-01", // + self.$route.query.selected_date,
        type: "GET",
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        },
        timeout: 10000,
        success: function(res) {
          self.$config.loading = false;

          if (res.status == "success") {
            console.log(res);
            self.logsArray = res.data.logsArray;
            var data =
              self.logsArray[self.logsArray.length - 1].LogData.logData;
            self.operatorData = res.data.operatorData;
            self.sign_image = data.sign_image;
            self.currDate = res.data.currentDate;
            self.shiftProperty = res.data.property;

            if (self.sign_image == "") {
              self.signReceived = false;
            }

            // generate logs html
            var html = "";

            if (res.data.logsArray.length > 0) {
              //debugger
              for (var i = 0; i < res.data.logsArray.length; i++) {
                if (
                  res.data.logsArray[i].LogData.logData.total_time ==
                  "0 hr: 0 min"
                ) {
                  //continue
                }
                var data = self.logsArray[i].LogData.logData;
                html =
                  '<div style="page-break-before: always !important;"></div>' +
                  '<div id = "row-' +
                  i +
                  '" style="display: inline-block; width: 100%;page-break-inside: avoid !important;">' + //style="page-break-before:always;"
                  '<section id = "row1-' +
                  i +
                  '" class="summary" style="float: left; width: 98%;   margin: 40px 1% 0 1%; -webkit-box-sizing: border-box;-moz-box-sizing: border-box;box-sizing: border-box;">' +
                  '<span style="float: left; width: 100%; font-size: 20px;  color: #0479bc; font-family: Arial, Helvetica, sans-serif;">Summary</span>' +
                  '<div class="summary-graph" style="float: left; width: 100%; border: 1px solid #ddd; padding: 15px; margin: 5px 0 0 0; -webkit-box-sizing: border-box;-moz-box-sizing: border-box;box-sizing: border-box;">' +
                  '<img style="float: left; width: 100%;" id="img-' +
                  i +
                  '"/>' +
                  '<div id="container-' +
                  i +
                  '" class="highcharts-container"/>' +
                  "</div>" +
                  "</section>" +
                  '<section class="driver-logs-table" style="float: left; width: 98%;   margin: 25px 1%;">' +
                  '<p style="float: left; width: 100%; font-size: 20px;  color: #0479bc; font-family: Arial, Helvetica, sans-serif;">' +
                  res.data.logsArray[i].Date +
                  "</p>";

                if (typeof res.data.logsArray[i] != "undefined") {
                  var k = 0;
                  for (var logData in res.data.logsArray[i].LogData.logData
                    .items) {
                    //conditionally open tr for displaying in same row
                    if (k % 2 === 0 || k == 0) {
                      html +=
                        '<div class="drivers-logs-block" style="float: left; width: 48%; margin: 0 2% 35px 0; -webkit-box-sizing: border-box;-moz-box-sizing: border-box;box-sizing: border-box;">';
                    } else {
                      html +=
                        '<div class="drivers-logs-block" style="float: right; width: 48%; margin: 0 0 35px 0; -webkit-box-sizing: border-box;-moz-box-sizing: border-box;box-sizing: border-box; ">';
                    }

                    //log table with timings
                    html +=
                      '<span style="float: left; background: #e6e7e8; color: #333; padding: 10px 15px; width: 30%;' +
                      'font-size: 18px; font-family: Arial, Helvetica, sans-serif;">' +
                      logData.charAt(0).toUpperCase() +
                      logData.slice(1) +
                      "</span>";

                    var lgData =
                      res.data.logsArray[i].LogData.logData.items[logData];
                    if (lgData.length > 0) {
                      for (var j = 0; j < lgData.length; j++) {
                        html +=
                          '<div class="driver-block" style="float: left; width: 100%; border: 1px solid #ddd; margin-top: -1px;margin-right: -1px; -webkit-box-sizing: border-box;-moz-box-sizing: border-box;box-sizing: border-box;">' +
                          '<div class="left" style="width: 60%; float: left; padding: 10px 15px; font-weight: bold; -webkit-box-sizing: border-box;-moz-box-sizing: border-box;box-sizing: border-box; font-family: Arial, Helvetica, sans-serif;">' +
                          lgData[j].key +
                          "</div>" +
                          '<div class="right" style="width: 40%; float: left; padding: 10px 15px; -webkit-box-sizing: border-box;-moz-box-sizing: border-box;box-sizing: border-box; font-family: Arial, Helvetica, sans-serif;">' +
                          lgData[j].value +
                          "</div>" +
                          "</div>";
                      }
                    }
                    html += "</div>";
                    if (k % 2 != 0) {
                      html += '<div style="clear:both;"></div>';
                    }
                    k++;
                  }
                  html += "</section>";
                }
                html +=
                  '<section class="sign" style="float: left;width: 80%;margin: 50px 10% 100px 10%; -webkit-box-sizing: border-box;-moz-box-sizing: border-box;box-sizing: border-box;page-break-after: always;">' +
                  '<div class="sign-text" style="float: left; width: 55%; color: #333; font-size: 16px; font-weight: bold; -webkit-box-sizing: border-box;-moz-box-sizing: border-box;box-sizing: border-box; font-family: Arial, Helvetica, sans-serif;">I certify that these entries are true and correct</div>' +
                  '<div class="drivers-sign" style="float: left; width: 40%; -webkit-box-sizing: border-box;-moz-box-sizing: border-box;box-sizing: border-box;">' +
                  '<div class="sign-space" style="float: left;width: 100%;border-bottom: 1px solid #ddd;margin-bottom: 10px; -webkit-box-sizing: border-box;-moz-box-sizing: border-box;box-sizing: border-box;">' +
                  '<img style="width: 100px;height: auto" id = "sign-img-' +
                  i +
                  '" alt="Logs not Signed Yet" />' +
                  "</div>" +
                  '<div class="drivers-sign-text" style="color: #333; font-size: 16px; font-weight: bold; float: left; width: 100%; -webkit-box-sizing: border-box;-moz-box-sizing: border-box;box-sizing: border-box; font-family: Arial, Helvetica, sans-serif;">Driver Signature</div>' +
                  "</div>" +
                  "</section>";
                ("<div>");
                if (i == 0) {
                  $(html).insertAfter("#operator-info");
                } else {
                  $(html).insertAfter("#row-" + (i - 1));
                }
                self.setSignImage(i, data.sign_image);
                self.generateChart(i, data.graph_data, data.total_hours);
              }
            }
            //set log data html in template body
            //$(html).insertAfter("#log_data_ref");
          }
        },
        error: function(jqXHR, exception, textstatus) {
          self.$config.loading = true;
          //if session expired
          if (textstatus === "timeout") {
            alert("Request timeout");
          } else if (jqXHR.responseJSON.code == 401) {
            self.$router.push("/v1/operator/login");
          } else if (jqXHR.responseJSON.code == 400) {
            alert(jqXHR.responseJSON.messge);
          }
        }
      });
    },
    setSignImage: function(divId, signImage) {
      document.getElementById("sign-img-" + divId).src = decodeURIComponent(
        signImage
      );
    },
    generateChart: function(divId, graph_data, total_hours) {
      // ***********************************************************************************************
      var colors = Highcharts.getOptions().colors;
      //console.log(dataArray);
      var self = this;

      self.chart = Highcharts.chart(
        "container-" + divId,
        {
          chart: {
            type: "line",
            lineColor: colors[0],
            plotBorderColor: "#346691",
            plotBorderWidth: 2,
            width: 1000,
            events: {
              load: function() {
                self.exportImageFromChart(divId);
              }
            }
            //plotBackgroundImage: 'https://www.highcharts.com/samples/graphics/skies.jpg',
          },
          credits: { enabled: false },
          tooltip: { enabled: false },
          rangeSelector: {
            selected: 1
          },
          title: {
            text: "Log Timings"
          },
          plotOptions: {
            line: {
              animation: false,
              marker: {
                enabled: false
              },
              dataLabels: { enabled: false },
              enableMouseTracking: true,
              states: {
                select: {
                  lineWidth: 10
                }
              },
              events: {
                click: function(e) {
                  //console.log(e.point.options.x+ " " + e.point.options.y);
                  console.dir(e);
                  this.setState(this.state === "select" ? "" : "select");
                }
              }
            }
          },
          xAxis: {
            type: "time",
            min: 0,
            max: 24,
            gridLineWidth: 1,
            tickInterval: 1,
            labels: {
              style: {
                fontSize: "14px"
              },
              formatter: function() {
                if (this.value == 0 || this.value == 24) {
                  return "M";
                } else if (this.value == 12) {
                  return "N";
                } else if (this.value > 12 && this.value < 24) {
                  return this.value - 12;
                } else {
                  return this.value;
                }
              }
            }
          },
          yAxis: [
            {
              title: {
                text: "Duty Status",
                align: "middle"
              },
              min: 0,
              max: 5,
              opposite: false,
              showLastLabel: true,
              labels: {
                formatter: function() {
                  //console.log(labelArray[this.value]);
                  return self.labelArray[this.value];
                }
              }
            },
            {
              classnName: ".highcharts-underline-hours-label",
              title: {
                text: "Duty Hours",
                align: "middle"
              },
              min: 0,
              max: 5,
              showLastLabel: true,
              labels: {
                style: {
                  fontSize: "14px",
                  fontWeight: "bold"
                },
                formatter: function() {
                  /*if(obj["'"+this.value+'"'] != null){
                               return secondsToHms(obj['"'+this.value+'"'].TotalShiftTime);
                            }*/
                  if (this.value == 0) {
                    return self.secondsToHms(total_hours["0"].TotalShiftTime);
                  } else if (this.value == 1) {
                    return self.secondsToHms(total_hours["1"].TotalShiftTime);
                  } else if (this.value == 2) {
                    return self.secondsToHms(total_hours["2"].TotalShiftTime);
                  } else if (this.value == 3) {
                    return self.secondsToHms(total_hours["3"].TotalShiftTime);
                  } else if (this.value == 4) {
                    return self.secondsToHms(total_hours["4"].TotalShiftTime);
                  }
                  return "";
                }
              },
              opposite: true
            }
          ],
          series: [
            {
              //keys: ['y', 'id'],
              type: "line",
              name: "Log Timings",
              data: graph_data /*[[0,1],[0.5,1], [1,1], [2,1],[2.5,2], [3,1], [4,1], [5,2],[6,2], [7,2], [8,2], [9,2], [10,2], [11,2],[12,2]
                            , [13,3], [14,3], [15,3], [16,3], [17,3],[18,3], [19,3], [20,3], /*[21,1], [22,1]
                            , [23,1],[24,2]]*/,
              step: true,
              tooltip: {
                valueDecimals: 4
              },
              cursor: "move",
              draggableX: false,
              draggableY: false,
              draggableSeries: false
              /*zoneAxis: 'x',
                    zones:[{
                        value: 12,
                        color: colors[0]
                    },{
                        value: 18,
                        color: colors[1]
                    }]*/
            }
          ]
        },
        function(chart) {
          /*
                    Comparing Selected Date with Current Date to decide whether text should be rendered for a Time Interval or not.
                    If same no need to show Time Interval as we are not showing line in that case.
                    Else draw Text.
                */
          /*var d1 = new Date().setHours(0, 0, 0, 0);
                var d2 = new Date(self.selected_date).setHours(0, 0, 0, 0);
                var same = d1.valueOf() === d2.valueOf();
                var dataPointsArray = chart.series[0].data;
                console.log(d1, d2, same);
                for (var i = 0; i < dataPointsArray.length; i++) {
                    //console.log(dataPointsArray[i]);
                    if (i == dataPointsArray.length - 1) {
                        var point1 = dataPointsArray[i];//chart.series[0].data[i],
                        if ((24 - point1.options.x) > 0 && !same) {
                            var time = parseFloat(Math.round((24 - point1.options.x) * 100) / 100).toFixed(2)
                            var text = chart.renderer.text(
                                (24 - point1.options.x).toString(),
                                point1.plotX + chart.plotLeft + 50,
                                point1.plotY + chart.plotTop - 10
                            ).attr({
                                zIndex: 5
                            }).css({
                                color: '#4572A7',
                                fontSize: '16px'
                            }).add();
                            //console.log("Last Annotations : "+ (24-point1.options.x).toString());
                        }
                    } else {
                        var point1 = dataPointsArray[i];
                        var nextVal = i + 1;
                        var point2 = dataPointsArray[nextVal];
                        if ((point2.options.x - point1.options.x) > 0) {
                            var time = parseFloat(Math.round((point2.options.x - point1.options.x) * 100) / 100).toFixed(2)
                            var text = chart.renderer.text(
                                time.toString(),
                                point1.plotX + chart.plotLeft + (point2.options.x - point1.options.x) * 25,
                                point1.plotY + chart.plotTop - 10
                            ).attr({
                                zIndex: 5
                            }).css({
                                color: '#4572A7',
                                fontSize: '16px',
                                fontWeight: 'bold',
                            }).add();
                            //console.log("Annotations : " + (point2.options.x-point1.options.x).toString());
                        }
                    }

                }*/
          //box = text.getBBox();
        }
      );
      // ***********************************************************************************************
    },
    secondsToHms: function(d) {
      d = Number(d);
      var h = Math.floor(d / 3600);
      var m = Math.floor((d % 3600) / 60);
      var s = Math.floor((d % 3600) % 60);

      var hDisplay = h;
      var mDisplay = m;
      var sDisplay = s;
      return hDisplay + ":" + mDisplay; // + sDisplay;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.chartrow {
  float: left;
  width: 100%;
}
/* h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
} */
</style>


// WEBPACK FOOTER //
// src/components/sendLogs.vue